var _templateObject;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import { BASE_SPACING, BASE_STYLES } from './constants';
import { Spacing } from '../theming';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import React from 'react';
var StyledInline = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n  margin-right: ", "px;\n"])), BASE_STYLES, function (props) {
  return props.size;
});

var Inline = function Inline(_ref) {
  var children = _ref.children,
      tag = _ref.tag,
      props = _objectWithoutProperties(_ref, ["children", "tag"]);

  return /*#__PURE__*/React.createElement(StyledInline, _extends({
    as: tag
  }, props), children);
};

Inline.Sizes = Spacing;
Inline.propTypes = {
  children: PropTypes.node,
  size: PropTypes.oneOf(Object.values(Inline.Sizes)),
  tag: PropTypes.oneOfType([PropTypes.string, PropTypes.func])
};
Inline.defaultProps = {
  size: BASE_SPACING
};
export default Inline;